import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';
import './styles/fase2.css';
import './styles/fase5.css';
import './styles/fase5d.css';
import './styles/fase6.css';
import './styles/fase7.css';
import './styles/fase8a.css';
import './styles/fase8b.css';
import './styles/password-reset.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
